<template>
  <v-app>
    <v-container
      id="app"
      class="pt-0 pl-0 pr-0"
      :fluid="$vuetify.breakpoint.width <= 1920"
    >
      <router-view> </router-view>
      <notify />
    </v-container>
  </v-app>
</template>

<script>
import notify from "./components/general/notification";
export default {
  name: "App",
  components: {
    notify,
  },
};
</script>

<style scoped>
#app {
  background-color: var(--v-background-base);
}
</style>
